<template>
  <div>
    <div class="container">
      <div class="card-container">
        <iframe
          src="https://t.guanyingtang.com/profile/psxk.html"
          width="100%"
          height="1900px"
          frameborder="0"
          ref="myIframe"
          @load="adjustHeight"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      protocol: [],
    };
  },
  created: {},
  methods: {
    adjustHeight() {
      const iframe = this.$refs.myIframe;
      iframe.style.height =
        iframe.contentWindow.document.body.scrollHeight + "px";
    },
  },
};
</script>

<style>
.container {
  width: 1280px;
  margin: auto auto;
}
.page-header {
  width: 1080px;
  margin-top: 30px;
  color: #333333;
  font-size: 20px;
}
.page-header > div {
  color: #333333;
  font-size: 20px;
}
.card-container {
  width: 100%;
  height: auto;
  display: flex;
  margin-bottom: 20px;
  padding-left: 20px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border: 1px solid #f2f2f2;
  margin-top: 20px;
  -webkit-box-shadow: 1px 1px 6px #f2f2f2;
  box-shadow: 1px 1px 6px #f2f2f2;
  font-size: 32px;
  color: #333333;
}
</style>
